module.exports = __webpack_public_path__ + "static/media/home-shopping.852c41f9.png";